customElements.get("sticky-atc") || customElements.define("sticky-atc", class extends HTMLElement {
    constructor() {
        super();
        this.selectors = {
            prodTitle: ".m-sticky-addtocart--title",
            mainImage: ".m-sticky-addtocart--image",
            addToCart: ".m-add-to-cart",
            buyNowBtn: ".m-product-dynamic-checkout",
            variantIdSelect: '[name="id"]',
            foxkitBtn: ".foxkit-button"
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
    }

    connectedCallback() {
        this.container = this.closest(".m-sticky-addtocart");

        // Start skjult
        this.container.style.setProperty("--m-translate-y", "0");
        this.container.style.opacity = "0";
        this.container.style.pointerEvents = "none";

        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.productId = this.dataset.productId;
        this.selectedVariantDefault = "true" === this.dataset.disableSelectedVariantDefault;
        this.domNodes = queryDomNodes(this.selectors, this.container);
        this.variantData = this.getVariantData();

        if (!window.location.search.includes("?variant=") && this.selectedVariantDefault && this.variantData && this.variantData.length > 1) {
            this.disableSelectedVariantDefault();
        }

        this.init();
        this.setStickyAddToCartHeight();

        this.addEventListener("change", () => {
            const t = this.querySelector(this.selectors.variantIdSelect).value;
            this.currentVariant = this.variantData.find(e => e.id === Number(t));
            this.updateButton(!0, "", !1);
            this.currentVariant ? 
                this.updateButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : 
                this.updateButton(!0, "", !0);
        });

        document.addEventListener("matchMobile", () => this.setStickyAddToCartHeight());
        document.addEventListener("unmatchMobile", () => this.setStickyAddToCartHeight());
    }

    getVariantData() {
        return this.variantData = this.variantData || JSON.parse(this.container.querySelector('[type="application/json"]').textContent);
    }

    init() {
        if (!this.mainAddToCart) return void this.container.style.setProperty("--m-translate-y", 0);

        const { prodTitle: t, mainImage: e, addToCart: i, buyNowBtn: a, foxkitBtn: o } = this.domNodes;
        if (a) this.enable_dynamic_checkout = true;

        // Observer target: produkt detaljer tabs
        this.observeTarget = document.getElementById("m-section-template--28648868610389__product-details-tabs");

        if (this.observeTarget && "IntersectionObserver" in window) {
            this.observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        // Sektionen er synlig -> vis sticky ATC
                        this.container.style.setProperty("--m-translate-y", "0");
                        this.container.style.opacity = "1";
                        this.container.style.pointerEvents = "auto";
                        document.documentElement.classList.add("stick-atc-show");
                    } else {
                        // Sektionen ikke synlig -> skjul sticky ATC
                        this.container.style.setProperty("--m-translate-y", "100%");
                        this.container.style.opacity = "0";
                        this.container.style.pointerEvents = "none";
                        document.documentElement.classList.remove("stick-atc-show");
                    }
                });
            }, { threshold: 0, rootMargin: "0px" });

            this.observer.observe(this.observeTarget);
        }

        t.addEventListener("click", () => __scrollToTop());
        e.addEventListener("click", () => __scrollToTop());

        if (this.hasCustomFields) {
            let t = false;
            const e = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
            e && e.forEach(e => {
                const i = e.querySelector(".form-field");
                if ("" == i.value && i.hasAttribute("required")) t = true;
            });

            if (t && i) {
                i.addEventListener("click", t => {
                    t.preventDefault();
                    t.stopPropagation();
                    __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
                });
            }

            if (a) {
                a.addEventListener("click", t => {
                    if (validateForm(this.mainProductInfo).length > 0) {
                        t.preventDefault();
                        t.stopPropagation();
                        __scrollToTop(this.mainProductForm, () => this.mainDynamicCheckout.click());
                    }
                }, true);
            }

            if (o) {
                o.addEventListener("click", t => {
                    t.preventDefault();
                    __scrollToTop(this.mainProductForm, () => this.mainAddToCart.click());
                });
            }
        }

        this.syncWithMainProductForm();
    }

    checkDevice() {
        const e = this.clientHeight + "px";
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", e);
    }

    disableSelectedVariantDefault() {
        const t = this.querySelector(".m-product-option--dropdown-select");
        t && (t.value = "");
    }

    updateButton(t = true, e, i = true) {
        const a = this.querySelector(".sticky-atc-form");
        if (!a) return;
        const o = a.querySelector('[name="add"]'),
              r = a.querySelector('[name="add"] > .m-add-to-cart--text');
        o && (t ? (o.setAttribute("disabled", "disabled"), e && (r.textContent = e)) : (o.removeAttribute("disabled"), o.classList.remove("disabled"), r.textContent = window.MinimogStrings.addToCart));
    }

    syncWithMainProductForm() {
        const t = this.querySelector('[name="id"]');
        window.MinimogEvents.subscribe(`${this.productId}__VARIANT_CHANGE`, async e => {
            e && (t.value = e.id);
        });
    }

    setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
    }
});